// removed by extract-text-webpack-plugin
module.exports = {"container":"pagination-bar__container___3mJF9","limit-controls":"pagination-bar__limit-controls___3qqDy","page-numbers":"pagination-bar__page-numbers___1mVbV","previous-button":"pagination-bar__previous-button___3DbLb","next-button":"pagination-bar__next-button___2n14R"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/pagination-bar.scss
// module id = 1311
// module chunks = 0